import axios from "axios";
import { ENDPOINT } from "../../api/EndPoints";
const getToken = async (maxAttempts = 3, delay = 500) => {
  for (let i = 0; i < maxAttempts; i++) {
    try {
      const userPersist = localStorage.getItem("persist:user");
      if (userPersist) {
        const parsedUser = JSON.parse(userPersist);
        if (parsedUser.USER_PARAM) {
          const userParam = JSON.parse(parsedUser.USER_PARAM);
          if (userParam?.TOKEN) {
            return userParam.TOKEN; 
          }
        }
      }
    } catch (error) {
      console.error("Error retrieving token from localStorage:", error);
    }
    await new Promise((resolve) => setTimeout(resolve, delay));
  }
  return null; 
};

let token = await getToken();
// GET API Function
const externalgetApi = async (
  endpoint,
  method = "GET",
  params = {},
  data = {},
  responseType = "json"
) => {
  const url = `${ENDPOINT}${endpoint}`;

  const config = {
    method,
    url,
    params,
    data,
    responseType,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  };

  try {
    // console.log("GET API (" + endpoint + ") PARAMS : ", params);
    const response = await axios(config);
    // console.log("GET API (" + endpoint + ") RESPONSE: ", response);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      console.warn("Token might not be ready, retrying...");
      token = await getToken(); 
      config.headers.Authorization = token ? `Bearer ${token}` : "";
      return axios(config).then((res) => res.data); 
    }
    console.error("API call error:", error);
    throw error;
  }
};

// POST API Function
const externalpostApi = async (endpoint, data = {}, responseType = "json") => {
  const url = `${ENDPOINT}${endpoint}`;

  const config = {
    method: "POST",
    url,
    data,
    responseType,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  };

  try {
    // console.log("POST API ENDPOINT : ", endpoint);
    console.log("Request data:", data);
    const response = await axios(config);
    // console.log("POST API (" + endpoint + ") RESPONSE: ", response);

    console.log("POST API Response data:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "API call error:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

const externalImagepostApi = async (endpoint, data = {}, responseType = "json") => {
  const url = `${ENDPOINT}${endpoint}`;

  const config = {
    method: "POST",
    url,
    data,
    responseType,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,

    },
  };

  try {
    // console.log("POST API ENDPOINT : ", endpoint);
    console.log("Request data:", data);
    const response = await axios(config);
    // console.log("POST API (" + endpoint + ") RESPONSE: ", response);

    console.log("POST API Response data:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "API call error:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};


const externaldeleteApi = async (
  endpoint,
  method = "DELETE",
  params = {},
  data = {},
  responseType = "json"
) => {
  const url = `${ENDPOINT}${endpoint}`;

  const config = {
    method,
    url,
    params,
    data,
    responseType,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
};

export { externalgetApi, externalpostApi, externaldeleteApi,externalImagepostApi };
